import { handleResponse } from "../../services/response.js";
import router from "../../router";

const user = null
const url = import.meta.env.VITE_APP_API_AUTH
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export default {
    state: initialState,
    actions: {
        signup({ dispatch, commit, getters },  data ) {
            if(!getters.isGuest) {
                router.push('/')
                return
            }
            return fetch(`${url}/identity/signup`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json', 'Accept-Language': getters.getAppLanguage},
                    body: JSON.stringify(data)
                }).then(handleResponse)
                .then(result => {
                    return result;
                })
        },
        confirmEmail({ dispatch, commit, getters }, token ) {
            return fetch(`${url}/identity/confirm-email/${token}`, {
                headers: {'Content-Type': 'application/json', 'Accept-Language': getters.getAppLanguage}
            }).then(handleResponse).then(result => result)
        },
        async recoveryPasswordRequest({ dispatch, commit, getters }, data ) {
            if(!getters.isGuest) {
                router.push('/')
                return
            }
            const params = new URLSearchParams(data).toString()
            const  resJson = await fetch(`${url}/identity/recovery-password`, {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept-Language': getters.getAppLanguage},
                body: params
            })
           return resJson.json()
        },
        async recoveryPasswordConfirm({ dispatch, commit, getters }, {token, password} ) {
            if(!getters.isGuest) {
                router.push('/')
                return
            }
            const params = new URLSearchParams({password:password}).toString()
            const  resJson = await fetch(`${url}/identity/recovery-password/${token}`, {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept-Language': getters.getAppLanguage},
                body: params
            })
            return resJson.json()
        },
    },
}